import { render } from "./password-set.vue?vue&type=template&id=a1790d68&scoped=true"
import script from "./password-set.vue?vue&type=script&lang=js"
export * from "./password-set.vue?vue&type=script&lang=js"

import "./password-set.vue?vue&type=style&index=0&id=a1790d68&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1790d68"]])

export default __exports__